module.exports = __webpack_public_path__ + "static/media/icon_expand.af4243f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon_expand.svg
// module id = 689
// module chunks = 0